import { render, staticRenderFns } from "./CreateUROButton.vue?vue&type=template&id=4576375f"
import script from "./CreateUROButton.vue?vue&type=script&lang=js"
export * from "./CreateUROButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports